export default __webpack_public_path__ + "static/media/CD-Wiz-UserGuide.9eb9478d.pdf";